/**
 * Tour steps for the AddClientModal (also used when editing a client).
 *
 * @param {Function} t - The i18next translation function.
 * @returns {import('react-joyride').Step[]}
 */
export const getAddClientModalSteps = (t) => [
    {
        target: '[data-tour="acm-modal"]',
        placement: 'center',
        title: t('tour.addClientModal.step-welcome-title'),
        content: t('tour.addClientModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="acm-photo"]',
        title: t('tour.addClientModal.step-photo-title'),
        content: t('tour.addClientModal.step-photo-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="acm-name"]',
        title: t('tour.addClientModal.step-name-title'),
        content: t('tour.addClientModal.step-name-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="acm-birthdate"]',
        title: t('tour.addClientModal.step-birthdate-title'),
        content: t('tour.addClientModal.step-birthdate-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="acm-contact"]',
        title: t('tour.addClientModal.step-contact-title'),
        content: t('tour.addClientModal.step-contact-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="acm-tabs"]',
        title: t('tour.addClientModal.step-food-tab-title'),
        content: t('tour.addClientModal.step-food-tab-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="acm-footer"]',
        title: t('tour.addClientModal.step-footer-title'),
        content: t('tour.addClientModal.step-footer-content'),
        disableBeacon: true,
    },
];
